import { widgets_prefix, widgets_with_data_id } from "./widgets";

export const popup = `{
      id
      title
      message
      delay
      view_count
      details {
        background_type
        background_image {
          alt
          url
          full_url
        }
        background_repeat
        background_size
        background_color
      }
      widgets ${widgets_with_data_id}
}`